import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { API } from "src/app/configuration/end-points";
import { NetworkService } from 'src/app/configuration/network.service';
import { SharedService } from 'src/app/pages/Services/shared.service';
import { environment } from 'src/environments/environment';
import { secureStorage } from 'src/app/pages/Services/secure-storage';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: "root",
})
export class LanguageService {
  //language code
  public selectedLang: any = {
    "langId": 1,
    "shDescNbr": null,
    "lgDescNbr": 29946,
    "used": true,
    "validated": true,
    "description": "English",
    "fileName" : ""
};
  public language = new BehaviorSubject<any>({
    "langId" : 1,
    "shDescNbr": null,
    "lgDescNbr": 29946,
    "used": true,
    "validated": true,
    "description": "English",
    "fileName": ""
  });
  public languages: any[] = [];

  constructor(
    public cookieService: CookieService,
    private networkService: NetworkService, private sharedService : SharedService) {}

  userData: any;
  confiObj: any;
  async getLanguages() {    
    // this.sharedService.getConfig().subscribe(result => this.confiObj = result);
    // if(!this.confiObj){
    //   await this.networkService.getDecryptedPassword(environment.KEYS_FILE_NAME, environment.CONFIG_FILE_NAME);
    // }else if(!this.confiObj["basicAuthPassword"] || 
    // !this.confiObj["username"] ||
    // !this.confiObj["MODULE_ID"] ||
    // !this.confiObj["RESET_PASS_CALLBACK_LINK"] ||
    // !this.confiObj["basicApiHost"] || 
    // !this.confiObj["apiHost"] ||
    // !this.confiObj["loginUrl"] ||
    // !this.confiObj["MODULE_NAME"])
    // {
    //  await this.networkService.getDecryptedPassword(environment.KEYS_FILE_NAME, environment.CONFIG_FILE_NAME);    
    // }
    let encr = secureStorage.hash("currentUser");
    let accessToken;
    this.cookieService.check(encr) && (accessToken = JSON.parse(secureStorage.decrypt(this.cookieService.get(encr))));
    return this.networkService.getLanguages();
  }

  public getLanguageId(lang, languages) {
    const index = languages.findIndex((item) => item.languagecode == lang);
    return languages[index]["id"];
  }

  public setLanguage(langObj: any) {
    this.sharedService.getConfig().subscribe(
      (confiObj) => {
        let fileName  = confiObj['MODULE_ID']+"_"+langObj.langId+"_"+confiObj['MODULE_NAME']+"_"+langObj.description;
        // console.log("fileName", fileName);
        langObj['fileName'] = fileName;
        this.language.next(langObj);
        this.sharedService.updateLocale(langObj.languagecode);
        this.sharedService.updateDateFormate(confiObj["dateFormat"][langObj.languagecode])
      }
    )    
    this.language.next(langObj);
    
  }

  public getLanguage(): Observable<string> {
    return this.language.asObservable();
  }
}
